import React from 'react';
import { getContent20 } from '@/client';
import { TestCarousel } from '@/components';

const TestCarouselModule = async () => {
  const { data } = await getContent20({
    query: {
      filter: ['contentType:articlePage'],
      fields: 'properties[promoTitle,promoImage]',
    },
  });

  return <div className="container">{data && <TestCarousel data={data} />}</div>;
};

export default TestCarouselModule;
